export default __webpack_public_path__ + "static/media/coordination_ladder_1.27fd5437.png";